import {
  PrescriptionsInfoMainCard,
  PrescriptionsInfoContainer,
  PrescriptionsInfoItem,
  PrescriptionsInfoText,
} from './PrescriptionsInfoCard.styles';
import { TitleTypography } from '../../styles';
import DifferenceOutlinedIcon from '@mui/icons-material/DifferenceOutlined';
import CurrencyExchangeOutlinedIcon from '@mui/icons-material/CurrencyExchangeOutlined';
import MapsHomeWorkOutlinedIcon from '@mui/icons-material/MapsHomeWorkOutlined';

export const PrescriptionsInfoCard = () => {
  return (
    <PrescriptionsInfoMainCard>
      <TitleTypography>¿Qué haremos con tu receta?</TitleTypography>
      <PrescriptionsInfoContainer>
        <PrescriptionsInfoItem>
          <DifferenceOutlinedIcon aria-label="Receta revisada por farmacéuticos" />
          <PrescriptionsInfoText>
            Al terminar la compra tu receta será revisada por nuestros químicos
            farmacéuticos.
          </PrescriptionsInfoText>
        </PrescriptionsInfoItem>
        <PrescriptionsInfoItem>
          <MapsHomeWorkOutlinedIcon aria-label="Retiro de receta a domicilio" />
          <PrescriptionsInfoText>
            De ser necesario, retiraremos el documento original al momento del
            despacho.
          </PrescriptionsInfoText>
        </PrescriptionsInfoItem>
        <PrescriptionsInfoItem>
          <CurrencyExchangeOutlinedIcon aria-label="Reembolso en caso de rechazo" />
          <PrescriptionsInfoText>
            En caso de que sea rechazada, te contactaremos para gestionar el
            reembolso.
          </PrescriptionsInfoText>
        </PrescriptionsInfoItem>
      </PrescriptionsInfoContainer>
    </PrescriptionsInfoMainCard>
  );
};
